module.exports = __webpack_public_path__ + "static/media/footer.1456fc1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/footer.png
// module id = 878
// module chunks = 0